
import React from "react";
import { ContaBancaria } from "@/types/financeiro";

interface ContaItemProps {
  conta: ContaBancaria;
}

const ContaItem: React.FC<ContaItemProps> = ({ conta }) => {
  return (
    <div className="flex justify-between items-center py-3">
      <div className="flex items-start">
        <input 
          type="checkbox" 
          className="mt-1 rounded border-gray-300 text-gray-500" 
          checked 
          readOnly 
        />
        <div className="ml-3">
          <div className="text-xs text-gray-600">{conta.banco} - {conta.descricao}</div>
          <div className="text-xs text-gray-500">
            ag {conta.agencia} / cc {conta.numero}
          </div>
        </div>
      </div>
      <div className="text-right text-xs text-gray-600">
        {conta.saldoAtual.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
      </div>
    </div>
  );
};

export default ContaItem;
